module.exports = __webpack_public_path__ + "intro-banner-03.89b1cc2becd9c0f32bd3.jpg";


//////////////////
// WEBPACK FOOTER
// D:/sachin/umc-new/umc/src/assets/images/intro-banner-03.jpg
// module id = ../../../../../src/assets/images/intro-banner-03.jpg
// module chunks = styles